var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoticesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.393 4.553h-1.82V1.32a.516.516 0 0 0-.514-.515h-17.31a.52.52 0 0 0-.374.164L11.36.98 4.306 7.974a.505.505 0 0 0-.064.078.511.511 0 0 0-.15.363v23.869c0 .284.231.515.515.515H7.9v1.881c0 .284.231.515.515.515h22.977c.284 0 .515-.231.515-.515V5.068a.516.516 0 0 0-.515-.515zM5.833 7.91l5.403-5.356.005 5.397-5.408-.041zm25.045-2.327v28.582H8.931V32.8h20.127a.515.515 0 0 0 .515-.515V5.583h1.305zM12.264 1.835h16.28v29.934H5.122V8.934l6.628.05h.017a.5.5 0 0 0 .352-.15.512.512 0 0 0 .152-.365l-.007-6.634z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 26.424h-6.144a.515.515 0 0 0 0 1.03h6.144a.515.515 0 0 0 0-1.03zM17.14 26.424H8.17a.515.515 0 0 0 0 1.03h8.97a.515.515 0 0 0 0-1.03zM7.655 24.112c0 .284.231.515.515.515h17.08a.515.515 0 0 0 0-1.03H8.17a.515.515 0 0 0-.515.515zM15.174 21.801H25.25a.515.515 0 0 0 0-1.03H15.174a.515.515 0 0 0 0 1.03zM8.17 21.801h3.256a.515.515 0 0 0 0-1.03H8.17a.515.515 0 0 0 0 1.03z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.145 5.4a4.498 4.498 0 0 0-4.495 4.5c0 2.484 2.012 4.5 4.495 4.5a4.503 4.503 0 0 0 4.505-4.5c0-2.484-2.016-4.5-4.505-4.5zm.455 2.25h-.9v2.7h.9v-2.7zm0 3.6h-.9v.9h.9v-.9zM17.55 9.9c0 1.989 1.611 3.6 3.6 3.6s3.6-1.611 3.6-3.6-1.611-3.6-3.6-3.6a3.599 3.599 0 0 0-3.6 3.6z",
    fill: "#F2B543"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticesIcon);
export default __webpack_public_path__ + "static/media/notices-icon.37c8ab9b766a707c35dcd7b9316ae058.svg";
export { ForwardRef as ReactComponent };